import { BancaView } from "@/pages/StatiCassaPage";

export default function BancaPage() {
  return (
    <div data-testid="banca-page">
      <div className="sw-page-title">
        <h1>Banca</h1>
        <div className="sw-breadcrumb">Home &gt; Banca</div>
      </div>
      <BancaView />
    </div>
  );
}
